// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter {\n  display: flex;\n  align-items: center;\n  height: 50px;\n  background: #f6f6ef;\n  font-size: 12px; }\n  .filter label {\n    margin: 0 10px; }\n  .filter select {\n    font-size: 14px;\n    padding: 0 4px 0 8px;\n    border: 1px solid #c3c3c3;\n    border-radius: 2px;\n    cursor: pointer;\n    color: #5c5c5c;\n    height: 28px;\n    background: #f6f6ef; }\n", ""]);
// Exports
module.exports = exports;
